import React from 'react'

export const Conditionally: React.FC<{
	condition?: boolean
}> = ({ condition, children }) => (condition ? <>{children}</> : null)
